import { useAppDispatch } from "app.hook";
import * as React from "react";
import { useEffect } from "react";
import { shallowEqual, useSelector } from "react-redux";
import { useHistory, useLocation } from "react-router";
import { ACCOUNT_FORGOT_PASSWORD_ROUTE, ACCOUNT_LOGIN_ROUTE, ACCOUNT_REGISTER_ROUTE, ACCOUNT_RESET_PASSWORD_ROUTE, ACCOUNT_EDIT_ROUTE } from "shared/constants/routes";
import { getProfileAPI } from "states/account/account.api";
import { fetchCustomer } from "states/customer/customer.slice";
import { selectSignIn, setSignOut } from "states/global-value/global-value.slice";
export interface IAuthManagementProps {
  children?:
  | JSX.Element
  | JSX.Element[]
  | React.ReactChild
  | React.ReactChild[]
  | React.ReactNode;
}

export const AuthManagement = ({ children }: IAuthManagementProps) => {
  const isLogged = useSelector(selectSignIn, shallowEqual);
  const dispatch = useAppDispatch();
  const location = useLocation();
  const history = useHistory();
  const isUnAuthPath = [ACCOUNT_LOGIN_ROUTE,
    ACCOUNT_REGISTER_ROUTE,
    ACCOUNT_FORGOT_PASSWORD_ROUTE,
    ACCOUNT_RESET_PASSWORD_ROUTE
  ];

  useEffect(() => {
    if (!isLogged && !isUnAuthPath.includes(location.pathname)) {
      window.location.href = ACCOUNT_LOGIN_ROUTE + "?callback=" + location.pathname;
    } else if (isLogged) {
      getProfileAPI()
        .then((result) => {
          let isRegularRole = result.data.roles.filter((role) => role.name.toLowerCase() === "regular").length > 0;
          if (!isRegularRole) {
            dispatch(setSignOut());
          }
        })
      dispatch(fetchCustomer());
      if (location.pathname === ACCOUNT_LOGIN_ROUTE) {
        history.push(ACCOUNT_EDIT_ROUTE)
      }
    }

  }, [isLogged, location])
  return (
    <>
      {isLogged ? children : <React.Fragment />}
    </>
  );
};
export default AuthManagement;
